<h1>Drivers</h1>
<mat-card class="drivers-box">
  <div *ngFor="let driver of drivers" style="width: 720px;">
    <app-driver-details [driver]='driver'></app-driver-details>
  </div>
</mat-card>
